import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { DeveloperFeatureFlagSettings } from "@/v2/apis/developerFeatureFlags/developer-feature-flags-apis";
import {
  getDeveloperFeatureFlags,
  upsertDeveloperFeatureFlags,
} from "@/v2/apis/developerFeatureFlags/developer-feature-flags-apis";
import { queryKeys } from "./keys";

export function useDeveloperFeatureFlags(orgId: string | null) {
  return useQuery({
    queryKey: orgId
      ? queryKeys.developerFeatureFlags.org(orgId)
      : ["developerFeatureFlags", "disabled"],
    queryFn: () => getDeveloperFeatureFlags(orgId!),
    enabled: !!orgId,
  });
}

export function useUpsertDeveloperFeatureFlags() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      orgId,
      settings,
    }: {
      orgId: string;
      settings: DeveloperFeatureFlagSettings;
    }) => upsertDeveloperFeatureFlags(orgId, settings),
    onSuccess: (_data, { orgId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.developerFeatureFlags.org(orgId),
      });
    },
  });
}
